import MentoringTeamsList from './MentoringTeamsList.vue';

export * from './types';
export default MentoringTeamsList;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/teamslist/index.ts